import {
  RESET_ADMIN_USER_PASSWORD_REQUEST,
  RESET_ADMIN_USER_PASSWORD_SUCCESS,
  RESET_ADMIN_USER_PASSWORD_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  error: null,
};

const resetAdminUserPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ADMIN_USER_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case RESET_ADMIN_USER_PASSWORD_SUCCESS:
      return { ...state, loading: false, error: null };
    case RESET_ADMIN_USER_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default resetAdminUserPasswordReducer;
